import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ChangeDetectionStrategy
} from '@angular/core';
import {
  CustomLabel,
  ProtectionWatermarkConfig,
  ProtectionWatermarkMode,
  ProtectionWatermarkSource,
  UserTest,
  ZalamoObject,
} from '../../../../graphql';
import { OrganizationService } from 'ZalamoLibrary/src/lib/core/organizations/organization.service';
import { VisualGuideManagerService } from 'ZalamoLibrary/src/lib/ui/visual-guide/visual-guide-manager.service';
import { translationProvider } from '@ui/nls/translations/translate.directive';
import { Required } from 'ZalamoLibrary/src/lib/core/decorators/Required';
import {
  PUBLIC_SESSION_ANT_AI_LIMIT,
  PUBLIC_SESSION_ANTI_AI_PHOTOS_PER_SESSION,
} from '../../public-session/consts';

const VISUAL_GUIDE_ID = 'WatermarkAdvancedEditor';

@Component({
    selector: 'app-water-management',
    templateUrl: './water-management.component.html',
    styleUrls: ['./water-management.component.scss'],
    providers: [translationProvider('publicSessionEditor')],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class WaterManagementComponent implements OnInit, OnDestroy {
  opacity = 0.8;
  lineOpacity = 0.8;
  startSize = 20;
  x = 50;
  y = 100;
  showLines = true;
  mode: ProtectionWatermarkMode = ProtectionWatermarkMode.Multi;
  customConfig;
  antiAiTest = UserTest.AntiAiWatermark;
  fileName = '';
  aiLevel = '1';
  @Input() text: Array<CustomLabel> = [];
  publicSessionContext = ZalamoObject.PublicSession;
  @Output() saved = new EventEmitter<ProtectionWatermarkConfig>();
  @Input() @Required context: ZalamoObject;
  publicSessionFreeAntiAiPhotosCount = PUBLIC_SESSION_ANT_AI_LIMIT;
  publicSessionAntiAiPhotosPerSession =
    PUBLIC_SESSION_ANTI_AI_PHOTOS_PER_SESSION;
  private _source: ProtectionWatermarkSource = ProtectionWatermarkSource.Image;

  get source(): ProtectionWatermarkSource {
    return this._source;
  }

  set source(value: ProtectionWatermarkSource) {
    if (
      value === ProtectionWatermarkSource.Text &&
      this.mode === ProtectionWatermarkMode.Custom
    ) {
      this.mode = ProtectionWatermarkMode.Multi;
    }
    this._source = value;
  }

  constructor(
    private cd: ChangeDetectorRef,
    public organizationService: OrganizationService,
    private visualGuideManagerService: VisualGuideManagerService,
    private elementRef: ElementRef,
  ) {}

  ngOnInit() {
    this.visualGuideManagerService.checkForGuide(
      VISUAL_GUIDE_ID,
      this.elementRef.nativeElement,
    );
  }

  save() {
    this.saved.emit({
      text: this.text,
      mode: this.mode,
      textOpacity: this.opacity,
      showLines: this.showLines,
      linesOpacity: this.lineOpacity,
      source: this._source,
      fileName: this.fileName,
      customConfig: this.customConfig,
      aiLevel: this.aiLevel,
    });
  }

  ngOnDestroy() {
    this.visualGuideManagerService.removeGuide(VISUAL_GUIDE_ID);
  }
}
